import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {AuthService} from "common-domain";
import {ActivatedRoute, Router} from "@angular/router";
import {TwoFactorGenericComponent} from "../../two-factor-generic.component";

@Component({
    selector: 'app-reset-password-mfa',
    templateUrl: '../../mfa-login-verification-code/mfa-login-verification-code.component.html',
    styleUrls: ['../../mfa-login-verification-code/mfa-login-verification-code.component.scss'],
    standalone: false
})
export class ResetPasswordMfaComponent extends TwoFactorGenericComponent {
  form: FormGroup;
  errorMessage: string;
  isVerifyTab = true;
  constructor(authService: AuthService, formBuilder: FormBuilder, activatedRoute: ActivatedRoute, private router: Router) {
    super(authService, formBuilder, activatedRoute);
  }

  onSubmitInfo(token: string, mfaCode: string, decodedToken: any): void {
    const correlationId = this.activatedRoute.snapshot.paramMap.get('correlationId');
    this.router.navigateByUrl(`/home/resetPasswordComplete/${token}/${correlationId}/${mfaCode}`);
  }

}
